import React from "react";
import styled from "styled-components";

const StyledSimpleText = styled.div`
  padding: 10px;
`;

function SimpleText({ field }) {
  if (!field || !field.value) {
    return null;
  }
  return <StyledSimpleText>{field.value}</StyledSimpleText>;
}

export default SimpleText;
